export default __webpack_public_path__ + "static/media/010-fireplace.ddf3d846.png";